export default __webpack_public_path__ + "static/media/nftvideo.0b382596.mp4";